import { FC, PropsWithChildren } from "react";
import { Box } from "@mui/material";

type Props = PropsWithChildren;

export const Content: FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        position: "relative",
        height: "100%",
        backgroundColor: "background.paper",
      }}
    >
      {children}
    </Box>
  );
};
